import {
  Car,
  Bike,
  Truck,
  Caravan,
  AlertTriangle,
  LifeBuoy,
  Map,
  Wrench,
  PackageOpen,
  Route,
  Zap,
  TruckIcon,
} from "lucide-react";
import { waLink } from "@/lib/constants";

const SERVICES = [
  {
    icon: Car,
    title: "Guincho 24 Horas",
    desc: "Atendimento imediato em qualquer hora do dia ou da noite.",
  },
  {
    icon: PackageOpen,
    title: "Remoção de Veículos",
    desc: "Remoção segura de carros para oficinas, residências ou destinos.",
  },
  {
    icon: Bike,
    title: "Transporte de Motos",
    desc: "Transporte especializado e seguro para motocicletas.",
  },
  {
    icon: Truck,
    title: "Transporte de Camionetes",
    desc: "Plataformas com capacidade para picapes e utilitários médios.",
  },
  {
    icon: Caravan,
    title: "Reboque de Trailers",
    desc: "Reboque de trailers e motorhomes para qualquer destino.",
  },
  {
    icon: Route,
    title: "Reboque de Carretinhas",
    desc: "Transporte de carretinhas e reboques de todos os tamanhos.",
  },
  {
    icon: AlertTriangle,
    title: "Atendimento em Acidentes",
    desc: "Pronta resposta em sinistros, com agilidade e empatia.",
  },
  {
    icon: LifeBuoy,
    title: "Auto Socorro Emergencial",
    desc: "Pane seca, bateria, pneu e emergências na estrada.",
  },
  {
    icon: Map,
    title: "Viagens Interestaduais",
    desc: "Transporte de veículos para qualquer cidade do Brasil.",
  },
  {
    icon: Wrench,
    title: "Transporte para Oficinas",
    desc: "Remoção direta até a oficina de sua confiança.",
  },
  {
    icon: Zap,
    title: "Remoção de Veículos Leves",
    desc: "Atendimento especializado para veículos leves e de passeio.",
  },
  {
    icon: TruckIcon,
    title: "Remoção de Veículos Pesados",
    desc: "Transporte de utilitários pesados, vans, furgões e caminhonetes de grande porte com segurança.",
  },
];

export const Services = () => {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="section-pad bg-[#0a0a0a] relative overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-30"></div>

      <div className="container-custom relative">
        <div className="max-w-3xl mb-14">
          <span className="overline">Nossos Serviços</span>
          <h2 className="mt-3 font-display uppercase font-bold text-white text-4xl md:text-5xl leading-tight tracking-tight">
            Atendemos todo tipo de{" "}
            <span className="text-[#d90429]">emergência veicular</span>
          </h2>
          <p className="mt-5 text-gray-400 text-lg">
            Da pane mecânica ao transporte interestadual, operamos com frota
            moderna e equipe treinada para resolver o seu problema — sem
            espera.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <a
                key={i}
                href={waLink(`Olá! Preciso de ${s.title} em Ribeirão Preto.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${i}`}
                className="card-dark p-7 group block"
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="w-14 h-14 bg-[#d90429]/10 border border-[#d90429]/30 flex items-center justify-center group-hover:bg-[#d90429] transition-colors">
                    <Icon className="w-7 h-7 text-[#d90429] group-hover:text-white transition-colors" />
                  </div>
                  <span className="font-display uppercase text-xs tracking-[0.3em] text-gray-600 group-hover:text-[#d90429] transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display uppercase font-bold text-white text-xl mb-2 leading-tight">
                  {s.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {s.desc}
                </p>
                <div className="mt-5 flex items-center gap-2 text-[#25d366] font-display uppercase tracking-wider text-xs opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="fa-brands fa-whatsapp text-base" aria-hidden></i>
                  Solicitar Agora →
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
